// export const BASE_URL = "https://api.eli-soft.ir/";
export const BASE_URL = "https://api.soutbartar.com/";
// const BASE_URL_ME = "http://localhost:3000/";
const BASE_URL_ME = "https://soutbartar.com/";

// *** * * * * Shoppings
export const PRODUCT_DETAILS = "shop/product/";
export const PRODUCT_FILTER = "shop/products/";
export const ADD_COMMENT = "shop/add-comment/";

// *** * * * * Invoices
export const ADD_TO_CART = "invoices/add-cart/";
export const REMOVE_ITEM_ORDER = "invoices/remove-item-cart/";
export const PAYMENT_CART = "invoices/payment-cart/";
export const GET_ALL_ORDER = "invoices/user-orders/";

// *** * * * * Accounts
export const ACCOUNT_REGISTER = "account/register/";
export const ACCOUNT_ACTIVE = "account/active/";
export const ACCOUNT_LOGIN = "account/login/";
export const GET_USER_PROFILE = "account/get-user/";
export const UPDATE_PROFILE = "account/get-user/";
export const ADD_NEW_ADDRESS = "account/add-address/";
export const PASSWORD_RECOVERY = "account/recovery/";
export const USER_ADDRESS = "account/user-address/";
export const DELETE_ADDRESS = "account/delete-address/";

// *** * * * * Zarin Pal
export const ZARINPAL_CREATE_LINK = "zarinpal/link/";
export const ZARINPAL_VERIFICATION = "zarinpal/verification/";
export const CALLBACK_PAYMENT = BASE_URL_ME + "Payment";

// *** * * * * Settings
export const CONTACT_US = "setting/contact-us/";

//**************************************** Url Site
export const HOME_URL_LOCAL = "/"; //* Home
export const LOGIN_URL_LOCAL = "/Account/Login";
export const CHANGE_PASSWORD_URL_LOCAL = "/Account/ChangePassword";
export const REGISTER_URL_LOCAL = "/Account/Register";
export const SECTION_USER_URL_LOCAL = "/Account/SectionUser";
export const PROFILE_URL_LOCAL = "/Account/Profile";
export const ORDERS_URL_LOCAL = "/Account/Orders";
export const ABOUTUS_URL_LOCAL = "/About-Us"; //* About Us
export const CONTACTUS_URL_LOCAL = "/Contact-Us"; //* Contact Us
export const FAQ_URL_LOCAL = "/Faq"; //* Frequently asked questions
export const SHOPPINGCART_URL_LOCAL = "/Shopping-Cart"; //* Shopping Cart
export const SEARCH_PRODUCT_URL_LOCAL = "/Search"; //* Filter Product
//! *** / * / * Functions
export const GOTOPRODUCTDETAILS_URL_LOCAL = (slug) => {
  //* generate url product details
  return "/Product/" + slug;
};
export const RETURNURLLOGIN_URL_LOCAL = (url) => {
  //* generate url return login
  return LOGIN_URL_LOCAL + "?redirect=" + url;
};
export const ORDER_DETAILS_URL_LOCAL = (code) => {
  //* generate url return Order Details
  return ORDERS_URL_LOCAL + "/" + code;
};
